import React from 'react';
import { useHistory } from 'react-router-dom';
import { Body, Grid, IconButton } from '@walmart-web/livingdesign-components';
import {
  ChevronLeft as ChevronLeftIcon,
  QuestionCircle as QuestionCircleIcon
} from '@livingdesign/icons';
import { Tooltip } from '@material-ui/core';

import styles from './styles.module.css';
import useToggle from '../../../hooks/useToggle.ts';
import ProductTestingResourcesPanel from '../../ProductTestingResourcesPanel/index.tsx';
import { logger } from '../../../utils/logger.js';

const ActivityNameHeader = ({ activityName }) => {
  const history = useHistory();
  const { value, toggle } = useToggle();

  const handleBackClick = () => {
    logger.clickStream('back_btn_from_activity_name_header');
    history.replace('/activities/product-testing');
  };

  return (
    <Grid className={styles.container}>
      <Grid onClick={handleBackClick} className={styles.backContainer}>
        <IconButton
          a11yLabel="chevron-left-icon"
          size="medium"
          data-testid="back-btn"
        >
          <ChevronLeftIcon />
        </IconButton>
        <Body
          UNSAFE_className={styles.heading}
          size="large"
          data-testid="activity-name-text"
        >
          {activityName}
        </Body>
      </Grid>

      <Tooltip title="Resources" placement="right">
        <IconButton
          a11yLabel="help icon button"
          size="medium"
          data-testid="help-icon-btn"
          onClick={toggle}
        >
          <QuestionCircleIcon />
        </IconButton>
      </Tooltip>
      <ProductTestingResourcesPanel onClose={toggle} isOpen={value} />
    </Grid>
  );
};

export default ActivityNameHeader;
